"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable */
var load_themed_styles_1 = require("@microsoft/load-themed-styles");
load_themed_styles_1.loadStyles([{ "rawString": ".scrollDisabled_11e8d933{overflow:hidden !important}\n" }]);
exports.scrollDisabled = "scrollDisabled_11e8d933";
//# sourceMappingURL=scroll.scss.js.map